import { authApi, type AuthenticatedUser } from '@api/services/auth';

const getCurrentUser = async (
  options?: RequestInit,
): Promise<AuthenticatedUser> => {
  const { data } = await authApi.currentUser(options);

  if ('result' in data && data.result) return data.result;

  throw new Error('Empty response result');
};

export default getCurrentUser;
